import React from 'react';
import { findDOMNode } from 'react-dom';
import { Tooltip , Statistic } from 'antd';
// import getTextWidth from '@utils/DOM/getTextWidth';


const align = {
  offset: [0, -15],
};

export default class SummaryItem extends React.PureComponent<any> {
  state = {
    minHeaderWidth: 0,
    showTooltip: false,
  };

  private node: null | HTMLDListElement = null;
  private textNode: null | HTMLSpanElement = null;

  componentDidMount() {
    // eslint-disable-next-line react/no-find-dom-node
    this.node = findDOMNode(this) as HTMLDListElement || null;
    this.calcTextWidth();
  }
  componentDidUpdate(prevProps: any) {
    // eslint-disable-next-line react/no-find-dom-node
    this.node = findDOMNode(this) as HTMLDListElement || null;
    if (this.props.value !== prevProps.value) {
      this.calcTextWidth();
    }
  }

  render() {
    const { value, metric } = this.props;

    // TODO: test ellipsis tooltip scenario
    // const textWidth = getTextWidth(metric, { fontSize: '24px' }) || 175;

    return (
      <Tooltip
        title={this.state.showTooltip ? value : ''}
        align={align}
        placement="bottom"
      >
        <Statistic
          title={metric}
          value={value}
        />
      </Tooltip>
    );
  }

  private calcTextWidth() {
    if (this.node === null) {
      return;
    }
    this.textNode = this.node.querySelector('.ant-statistic-content-value');
    const showTooltip = this.textNode && this.textNode.scrollWidth > this.textNode.clientWidth;
    if (showTooltip !== this.state.showTooltip) {
      this.setState((state) => ({ ...state, showTooltip: true }));
    }
  }
}
